module.exports = __webpack_public_path__ + "img/SI.f53de08d.svg";